import { Box, Typography, useTheme } from "@mui/material";
import { ForwardedRef, forwardRef } from "react";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import { IOrder } from "../../../../../types/owner";
import { convertToJalali } from "../../../../../utils/functions";
import CustomButton from "../../../../components/CustomButton";

interface Props {
  handleDetails: (orderId: string) => void;
  order: IOrder;
}

const OrderCard = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const {
      code,
      receiverAddress,
      registrationInfo,
      id,
      goodsInfo,
      senderAddress,
      isConfirm,
    } = props.order;
    const { handleDetails } = props;
    const theme = useTheme();

    // const navigate = useNavigate();

    return (
      <Box
        ref={ref}
        sx={{
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
          display: "flex",
          // border: "1px solid gray",
          borderColor: "info.main",
          borderStyle: "solid",
          gap: "4px",
          borderWidth: "1px",
          borderRadius: "16px",
          flexDirection: "column",
          padding: "8px",
          backgroundColor: "background.default",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",
            justifyContent: "space-between",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "info.light",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "6px",
                borderRadius: "8px",
              }}
            >
              <Boxoutline color={theme.palette.textColor.main} />
            </Box>
            <Box
              sx={{
                flex: "1",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                نام محموله: {goodsInfo.name || "-----"}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px",
                  borderRadius: "8px",
                  gap: "4px",
                }}
              >
                <Typography
                  noWrap
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  شماره سفارش:{" "}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                  color="primary.main"
                >
                  {code}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px",
                  borderRadius: "8px",
                  gap: "4px",
                }}
              >
                <Typography
                  noWrap
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  مبدا:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                  color="primary.main"
                >
                  {senderAddress?.cityName}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px",
                  borderRadius: "8px",
                  gap: "4px",
                }}
              >
                <Typography
                  noWrap
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  مقصد:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                  color="primary.main"
                >
                  {receiverAddress?.cityName}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "info.light",
                borderRadius: "5px",
                paddingX: "8px",
                paddingY: "4px",
              }}
            >
              <Typography
                color="textColor.main"
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                }}
              >
                {convertToJalali(registrationInfo.insertDateTime).split(" ")[1]}
              </Typography>
            </Box>
            <Box
              sx={{
                backgroundColor: theme.palette.primary[50],
                borderRadius: "5px",
                paddingX: "4px",
                paddingY: "4px",
              }}
            >
              <Typography
                textAlign={"center"}
                color="primary.main"
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                }}
              >
                {isConfirm === null
                  ? "در انتظار تایید"
                  : isConfirm
                  ? "تایید شده"
                  : "عدم تایید"}
              </Typography>
            </Box>
          </Box>
        </Box>
        {/* <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          backgroundColor: "background.default",
          padding: "8px",
          borderRadius: "8px",
          borderColor: "info.main",
          borderWidth: "1px",
          borderStyle: "solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <LocationFill size={18} color={theme.palette.primary.main} />
          <Typography
            variant="body2"
            sx={{
              color: "primary.main",
            }}
          >
            {senderAddress.cityName}
          </Typography>
        </Box>
        <ArrowStepLeft color={theme.palette.textColor.main} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <LocationFill size={18} color={theme.palette.secondary.main} />
          <Typography
            variant="body2"
            sx={{
              color: "secondary.main",
            }}
          >
            {receiverAddress.cityName}
          </Typography>
        </Box>
      </Box> */}
        <Box
          sx={{
            mt: 1,
            display: "flex",
            gap: "8px",
          }}
        >
          <CustomButton
            type="outlined"
            flex={1}
            // loading
            justifyContent="center"
            // onClick={() => navigate("/owner/manage-orders/1")}
            onClick={() => handleDetails(id)}
            title="جزییات"
            bgColor="secondary.main"
            textColor="#fff"
            fSize="14px"
            fWeight="700"
            px="10px"
            py="10px"
            borderRadius="10px"
            icon2={<ArrowTickLeft size={16} color={"#fff"} />}
          />
        </Box>
      </Box>
    );
  }
);

export default OrderCard;
